const getters = {
  token: state => state.auth.token,
  userid: state => state.auth.userid,
  username: state => state.auth.username,
  sidebar: state => state.app.sidebar
};
export default getters;
